module.exports = __webpack_public_path__ + "static/media/resume.1cb34e72.pdf";